export default "__VITE_PUBLIC_ASSET__a0d83ae8__"